import stageContactsConfig from "./contacts.config";

// Greece has a single office currently; extendable for future branches
const officesConfig = [stageContactsConfig];

export default officesConfig;
